/* import __COLOCATED_TEMPLATE__ from './escalation-section.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type Guideline from 'embercom/models/ai-agent/guidelines';
import type EscalationRule from 'embercom/models/ai-agent/escalation-rule';
import { type PulseAccordionSection } from 'glint/pulse';

interface Signature {
  Element: HTMLDivElement;
  Blocks: {
    escalationHeader: [
      {
        header: PulseAccordionSection['Header'];
        guideline?: Guideline;
      },
    ];
    escalationBody: [
      {
        guideline?: Guideline;
      },
    ];
  };
  Args: {
    accordionSection: PulseAccordionSection;
    selectedEscalationType: EscalationType;
    guideline?: Guideline;
    escalationRule?: EscalationRule;
  };
}

type EscalationType = 'rule-based' | 'text-based';

export default class EscalationSection extends Component<Signature> {
  @tracked selectedEscalationType = this.args.selectedEscalationType;
  @tracked guideline = this.args.guideline;
  @tracked escalationRule = this.args.escalationRule;

  @action
  onSelectionChange(escalationType: EscalationType) {
    //TODO: trigger confirmation modal
    // on change, clear one (guideline / rule) and create a new one of the other type
    this.selectedEscalationType = escalationType;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Guidance::EscalationSection': typeof EscalationSection;
    'ai-agent/guidance/escalation-section': typeof EscalationSection;
  }
}
